import SignUpForm from "../../components/sign-up-form/sign-up-form.component";
import SignInForm from "../../components/sign-up-form/Sign-in-form.component";

import { Route, Routes } from "react-router-dom";

const Authentication = () => {
  return (
    <Routes>
      <Route index element={<SignInForm />} />
      <Route path=":sign-up" element={<SignUpForm />} />
    </Routes>
  );
};

export default Authentication;
